import { DataItem } from 'scrivito'

import { isString } from '@/utils/isString'

interface ActivityRow {
  id: string
  activity: DataItem
}

type ActivityTimelineEntry<T extends ActivityRow> =
  | { kind: 'activity'; id: string; item: T }
  | { kind: 'automation'; id: string; items: T[] }

/**
 * Groups automation events only within the timeline section passed by the
 * caller. Regular activities stay as individual entries and retain their
 * relative order.
 */
export const groupAutomationEvents = <T extends ActivityRow>(
  items: T[],
): ActivityTimelineEntry<T>[] => {
  const entries: ActivityTimelineEntry<T>[] = []
  const entryIndexes = new Map<string, number>()

  items.forEach((item) => {
    if (item.activity.get('type') !== 'MARKETING_AUTOMATION_EVENT') {
      entries.push({ kind: 'activity', id: item.id, item })
      return
    }

    const groupingId = item.activity.get('groupingId')
    if (!isString(groupingId) || !groupingId) {
      entries.push({ kind: 'automation', id: item.id, items: [item] })
      return
    }

    const entryId = `automation-${groupingId}`
    const entryIndex = entryIndexes.get(entryId)
    if (entryIndex === undefined) {
      entryIndexes.set(entryId, entries.length)
      entries.push({ kind: 'automation', id: entryId, items: [item] })
      return
    }

    const entry = entries[entryIndex]
    if (entry?.kind === 'automation') entry.items.push(item)
  })

  return entries
}
